import React from 'react'
export const TicketsAppContext = React.createContext({
  cart: {
    id: 1,
    items: [],
    loading: false,
    exchangeCredit: 0,
    exchangeDetails: null
  },
  step: 1,
  events: [],
  alerts: [],
  membership: null,
  selectedDate: null,
  previewedEvent: null,
  chosenEvent: null,
  chosenAddOn: null,
  cartEvents: [],
  error: null,
  exchangeId: null,
  actions: {
    selectDay: () => {},
    updateStep: () => {},
    previewEvent: () => {},
    selectEvent: () => {},
    updateItem: () => {},
    setChosenEvent: () => {},
    addEventToCart: () => {},
    selectAddOn: () => {},
    clearAddOn: () => {},
    goToCart: () => {}
  }
})
